import { createFileRoute } from '@tanstack/react-router';
import { PeopleListPage } from '../features/records/PeopleListPage';

export const Route = createFileRoute('/people/')({
  component: PeopleListPage,
});
